import Customer from "@/views/customer/customer"

export default {
    path: '/Customer',
    name: 'Customer',
    component: Customer,
  }


// WEBPACK FOOTER //
// ./src/router/customer/index.js